export class ProductMatrix {
    id?: string;
    productCode?: string;
    productName?: string;
    descendants?: ProductMatrix[];
    ancestorProductCodes?: ProductMatrix[];
}
